import React from "react";

const PortfolioPage = () => {
  return <div className="page-container"></div>;
};

export default PortfolioPage;
